import React from "react";
import Footer from "./Footer";

const Error = () => {
	return (
		<>
			<div className="flex justify-center text-black items-center text-3xl text-red">
				Error-404 Not found
			</div>
			<Footer />
		</>
	);
};

export default Error;
